import Loadable from 'react-loadable';

import { FooterTheme } from '@rover/kibble/styles';
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import retry from '@rover/rsdk/src/modules/Network/retry';
import Route from '@rover/types/src/Route';

import Loading from '../client/Loading';

const reportAndBlockPage = Loadable({
  loader: () =>
    retry(
      () =>
        import(/* webpackChunkName: "ReportAndBlockPage" */ '@rover/pages/src/report-and-block/')
    ),
  loading: Loading,
});

const REPORT_ROUTE = {
  pageName: 'report-and-block',
  component: reportAndBlockPage,
  componentName: 'ReportAndBlockPage',
  exact: true,
};
const routes: Route[] = [
  {
    path: '/misconduct/report/conversation/:opk/',
    ...REPORT_ROUTE,
  },
  {
    path: '/misconduct/report/provider_rating/:opk/',
    ...REPORT_ROUTE,
  },
  {
    path: '/misconduct/report/requester_review/:opk/',
    ...REPORT_ROUTE,
  },
].map((route) => ({
  ...route,
  concept: CONCEPTS.communications.trust_and_safety,
  pageCategory: 'report-and-block-ssr',
  footerTheme: FooterTheme.LIGHT,
  cacheTag: ['page-report-and-block', 'page-all'],
  isReactQueryRoute: true,
}));

export default routes;
